import {
  buildFeatureList,
  buildPaymentMethodGenerators,
  type CountrySchema,
} from '@tectonics/prs/country';
import type { PaymentSpecGenerator } from '@tectonics/prs/payment-spec/generator';

export const buildPaymentSpecGenerator = (
  { countrySchema }: { readonly countrySchema: CountrySchema },
): PaymentSpecGenerator => ({
  features: ({ incomingPayment }) => (
    buildFeatureList(
      [...countrySchema.display, ...countrySchema.fields],
      incomingPayment,
    )
  ),
  ...buildPaymentMethodGenerators(countrySchema.paymentMethods),
});
